import { render } from "./AddEditCommunicationDialog.vue?vue&type=template&id=0f23d0c6&scoped=true&ts=true&lang=pug"
import script from "./AddEditCommunicationDialog.vue?vue&type=script&lang=ts"
export * from "./AddEditCommunicationDialog.vue?vue&type=script&lang=ts"

import "./AddEditCommunicationDialog.vue?vue&type=style&index=0&id=0f23d0c6&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f23d0c6"]])

export default __exports__